export interface ResponseData<T> {
  count: number,
  page: string,
  limit: string,
  results: T[]
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DEFAULT_PAGINATED: ResponseData<any> = {
  count: 0,
  results: [],
  page: '1',
  limit: '10',
};
